import React, { useRef, useEffect } from 'react';
import { DarkBackground } from 'scy/Background';
import { WideContainer, NarrowContainer } from 'scy/layouts';
import { Hero, Title, SmallUppercase, Paragraph } from 'scy/text';
import { TextHR } from 'scy/HR';
import { pageContainer, borderBox, textCenter } from 'scy/utils.mod.scss';
import styles from './styles.mod.scss';
import margin from 'scy/margin.mod.scss';

export default function Careers() {
  const hireJobsRef = useRef();

  useEffect(() => {
    if (hireJobsRef.current) {
      const script = document.createElement('script');
      script.setAttribute('id', 'hire-embed-loader');
      script.setAttribute('async', true);
      script.setAttribute('defer', true);
      script.setAttribute(
        'src',
        'https://hire.withgoogle.com/s/embed/hire-jobs.js?company=sauceyit'
      );
      hireJobsRef.current.insertAdjacentElement('afterend', script);
    }
  }, []);

  return (
    <div className={`${pageContainer} ${borderBox} ${textCenter}`}>
      <DarkBackground className={styles.background}>
        <Hero className={styles.hero}>Join Saucey HQ</Hero>
      </DarkBackground>

      <WideContainer>
        <Title responsive tag="h2">
          Be a part of something great
        </Title>
        <SmallUppercase tag="h3" className={styles.subtitle}>
          Build the future of an industry
        </SmallUppercase>
      </WideContainer>

      <NarrowContainer>
        <Paragraph marginClass={margin.md}>
          It’s not everyday you go to work knowing what you’re building is
          changing an entire industry. Some companies build sales tools, some
          build games or social apps… Saucey is changing one of the oldest
          industries in the world.
        </Paragraph>
        <Paragraph marginClass={margin.md}>
          At Saucey, we put big ideas first, and the best ones always win. If
          you’re ready to join a fast paced/innovative team, then we look
          forward to hearing from you.
        </Paragraph>
      </NarrowContainer>

      <div className={styles.jobsContainer}>
        <TextHR className={styles.hr}>Open Positions</TextHR>
        <div className="hire-jobs" ref={hireJobsRef} />
      </div>
    </div>
  );
}
